import { render, staticRenderFns } from "./stuclazz-list.vue?vue&type=template&id=37e68b86&"
import script from "./stuclazz-list.vue?vue&type=script&lang=js&"
export * from "./stuclazz-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports